module.exports = __webpack_public_path__ + "static/cat-29ca27b36407275aac0be6d271155860.png";